<template>
  <v-form-create
    v-if="access.create_good_sale || (item_id ? true : false)"
    large
    name="item"
    :top_title="item_id ? 'update_item' : 'create_item'"
  >
    <VProgress v-if="method_in_process" />
    <v-form v-model="is_valid">
      <v-layout row>
        <!-- Start header fields -->
        <v-flex md6 class="px-3">
          <v-combobox
            v-model="params.barcode"
            class="ma-0 pa-1"
            chips
            multiple
            :label="$t('barcode')"
            :readonly="!access.item_edit && (item_id ? true : false)"
            @click:append="itemSearchGetBarcodeMxik('barcode')"
            :append-icon="
              this.target === 'create' && this.params.barcode.length > 0
                ? 'mdi-database-search'
                : ''
            "
          />
        </v-flex>
        <v-flex v-if="!open_barcode" md6 class="px-3">
          <v-text-field
            v-model="params.name"
            ref="name"
            :rules="[fieldRules.required]"
            :label="$t('name')"
            :readonly="!access.item_edit && (item_id ? true : false)"
            @focus="$event.target.select()"
            :append-icon="
              this.target === 'create' && this.params.barcode.length > 0
                ? 'mdi-database-search'
                : ''
            "
            @click:append="itemSearchBarcode()"
          />
        </v-flex>
        <v-flex v-else-if="open_barcode" md6 class="px-3">
          <v-autocomplete
            v-model="suggestion_item"
            hide-no-data
            :loading="searching_composite_items"
            :items="suggestion_item_list"
            item-text="name"
            return-object
            v-on:update:search-input="itemSearchGetBarcode"
            @change="closeBarcodeDialog"
            class="pl-1 pr-1"
            autofocus
          >
            <template #item="data">
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium"
                  >{{ $t("name") }}:{{ data.item.name }}</v-list-item-title
                >
                <v-list-item-subtitle v-if="data.item.sold_by"
                  >{{ $t("sold_by") }}:
                  {{ data.item.sold_by }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </template>
            <!-- <v-btn text @click="closeBarcodeDialog" small>Cancel</v-btn> -->
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md6 px-3>
          <v-select
            v-model="params.sold_by"
            :label="$t('sold_by')"
            :items="sold_by_options"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </v-flex>
        <v-flex md6 px-3>
          <v-text-field
            v-model="params.brand"
            autocomplete="off"
            :label="$t('brand')"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </v-flex>
        <v-flex md6 px-3 v-if="!open_barcode_mxik && organization.is_ofd">
          <v-text-field
            v-model="params.mxik"
            :label="$t('mxik')"
            type="number"
            :readonly="!access.item_edit && (item_id ? true : false)"
            :rules="organization.is_ofd ? exampleRules : exampleRulesFalse"
            counter
            maxlength="17"
            :append-icon="'mdi-database-search'"
            @click:append="itemSearchBarcodeMxik()"
          />
          <!-- @input="itemSearchBarcodeMxikInput()" -->
        </v-flex>
        <v-flex v-else-if="open_barcode_mxik" md6 px-3>
          <v-autocomplete
            ref="autocomplete"
            v-model="suggestion_item_mxik"
            hide-no-data
            :loading="searching_composite_items_mxik"
            :items="suggestion_item_list_mxik"
            item-text="mxik"
            return-object
            @change="closeBarcodeDialogMxik"
            class="pl-1 pr-1"
            autofocus
            v-on:update:search-input="itemSearchGetBarcodeMxik"
            :rules="organization.is_ofd ? exampleRules : exampleRulesFalse"
          >
            <template #item="data">
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-medium"
                  v-if="data.item.mxik"
                >
                  {{ $t("mxik") }}:{{ data.item.mxik }} -
                  {{ data.item.mxikName }}</v-list-item-title
                >
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex md3 px-3 v-if="organization.is_ofd">
          <v-autocomplete
            v-model="suggestion_item_packages"
            hide-no-data
            :label="$t('packages')"
            :items="suggestion_item_list_packages"
            item-text="nameUz"
            @change="changePackages"
            return-object
            class="pl-1 pr-1"
          >
            <template #item="data">
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ data.item.nameUz }}</v-list-item-title
                >
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex v-if="organization.is_ofd" md3 px-3>
          <v-text-field
            v-model="params.nds_value"
            :label="$t('nds_value')"
            type="number"
            suffix="%"
            :rules="[numberRule]"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </v-flex>
        <v-flex v-else md12 class="pl-3 pr-3">
          <v-text-field
            v-model="params.nds_value"
            :label="$t('nds_value')"
            type="number"
            suffix="%"
            :rules="[numberRule]"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </v-flex>
        <v-flex md6 v-if="params.sold_by == 'box' || params.sold_by == 'pcs'">
          <v-layout>
            <v-flex md6 px-3>
              <v-text-field
                v-model.number="params.count_by_type"
                :label="$t('count_by_type')"
                type="number"
                ref="count_by_type"
                :rules="[fieldRules.require]"
                @focus="$event.target.select()"
                :readonly="!access.item_edit && (item_id ? true : false)"
              />
            </v-flex>
            <v-flex md6 px-3>
              <v-text-field
                v-model="params.barcode_by_type"
                :label="$t('barcode')"
                @focus="$event.target.select()"
                :readonly="!access.item_edit && (item_id ? true : false)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout
      row
      v-if="
        (target == 'update' &&
          is_variant_edit != true &&
          variant_items &&
          variant_items.length == 0) ||
        (variant_items && variant_items.length == 0)
      "
    >
      <v-flex md4 class="px-3">
        <vuetify-money
          v-model="params.price"
          :label="$t('price')"
          v-bind:options="
            params.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions
          "
          :readonly="!access.item_edit && (item_id ? true : false)"
        />
      </v-flex>
      <v-flex md2 class="px-3">
        <v-select
          v-model="params.price_currency"
          :label="$t('currency')"
          :items="currencies"
          :readonly="!access.item_edit && (item_id ? true : false)"
        />
      </v-flex>
      <v-flex md4 class="px-3">
        <vuetify-money
          v-model="params.cost"
          :label="$t('cost')"
          v-bind:options="
            params.cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions
          "
          :readonly="!access.item_edit && (item_id ? true : false)"
        />
      </v-flex>
      <v-flex md2 class="px-3">
        <v-select
          v-model="params.cost_currency"
          :label="$t('currency')"
          :items="currencies"
          :readonly="!access.item_edit && (item_id ? true : false)"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md2 class="px-3">
        <v-checkbox
          :readonly="!access.item_edit && (item_id ? true : false)"
          v-model="params.is_active"
          :label="$t('status')"
        />
      </v-flex>
      <v-flex md2 class="px-3" v-if="feature.delivery">
        <v-checkbox
          :readonly="!access.item_edit && (item_id ? true : false)"
          v-model="params.has_discount"
          :label="$t('discount')"
        />
      </v-flex>
      <v-flex md4 class="px-3" v-if="params.has_discount && feature.delivery">
        <vuetify-money
          v-model="params.old_price"
          :label="$t('old_price')"
          v-bind:options="
            params.price_currency === 'usd' ? moneyOptionsUSD : moneyOptions
          "
          :readonly="!access.item_edit && (item_id ? true : false)"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md6 class="px-3">
        <v-text-field
          v-model="params.sku"
          :label="$t('sku')"
          ref="sku"
          :rules="[fieldRules.required]"
          type="number"
          @focus="$event.target.select()"
          :readonly="!access.item_edit && (item_id ? true : false)"
        />
      </v-flex>
      <!-- <v-flex md3 class="px-3">
          <v-text-field
            v-model="params.hot_key"
            v-mask="hot_key_mask"
            :label="$t('hot_key')"
            ref="hot_key"
            @focus="$event.target.select()"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </v-flex> -->
      <v-flex md6 class="px-3">
        <v-menu offset-y v-bind:close-on-content-click="true">
          <template #activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="searchCategory"
              :value="params.category ? params.category.name : ''"
              :label="$t('category')"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </template>
          <v-card max-height="200" class="overflow-y-auto">
            <v-treeview
              dense
              activatable
              :disabled="!access.item_edit && (item_id ? true : false)"
              item-key="_id"
              :items="all_categories"
              @update:active="activate"
              :search="searchCategory"
            ></v-treeview>
          </v-card>
        </v-menu>
      </v-flex>
    </v-layout>
    <!-- <v-layout row>
        <v-flex md12 class="px-3">
          <v-autocomplete
              v-model="params.workgroups"
              :label="$t('workgroups')"
              item-text="name"
              item-value="_id"
              :items="workgroups"
              multiple
              chips
          />
        </v-flex>
      </v-layout> -->
    <v-layout row>
      <v-flex md6 class="px-3 mt-12">
        <v-textarea
          height="100"
          outlined
          v-model="params.description"
          :maxlength="max"
          :counter="300"
          label="Description"
          :readonly="!access.item_edit && (item_id ? true : false)"
        ></v-textarea>
        <!--        :rules="nameRules"-->
      </v-flex>
    </v-layout>
    <!--    <v-layout row>-->
    <!--      <v-flex md6 class="px-3">-->
    <!--        <v-checkbox v-model="params.show_on_bot" :label="$t('show_on_bot')" />-->
    <!--      </v-flex>-->

    <!--      <v-flex v-if="params.show_on_bot" md6 class="px-3">-->
    <!--        <v-text-field-->
    <!--            v-model="params.name_on_bot"-->
    <!--            :label="$t('name_on_bot')"-->
    <!--            ref="name_on_bot"-->
    <!--            :rules="[fieldRules.required]"-->
    <!--            @focus="$event.target.select()"-->
    <!--        />-->
    <!--      </v-flex>-->
    <!--    </v-layout>-->
    <!-- :true-value="suggestion_item_list_mxik[0].label>0"
            :false-value="suggestion_item_list_mxik[0].label===0" -->

    <v-layout>
      <v-list-item class="ma-0 pa-0">
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">
            {{ $t("marking") }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-if="!item_id && suggestion_item_list_mxik.length > 0"
            readonly
            v-model="suggestion_item_list_mxik[0].label"
          />
          <v-switch v-else v-model="params.marking" readonly />
          <!-- :readonly="this.suggestion_item_list_mxik.label?true:false" -->
        </v-list-item-action>
      </v-list-item>
    </v-layout>
    <v-layout>
      <v-list-item class="ma-0 pa-0">
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">
            {{ $t("show_on_bot") }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            :readonly="!access.item_edit && (item_id ? true : false)"
            v-model="params.show_on_bot"
          />
        </v-list-item-action>
      </v-list-item>
    </v-layout>

    <v-layout>
      <v-list-item class="ma-0 pa-0">
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">
            {{ $t("series") }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            :readonly="!access.item_edit && (item_id ? true : false)"
            v-model="params.composite_item"
          />
        </v-list-item-action>
      </v-list-item>
    </v-layout>

    <!-- Dimentions -->

    <p class="black--text font-weight-medium">
      {{ $t("dimentions") }}
    </p>
    <v-layout>
      <v-flex md6>
        <v-layout>
          <v-flex md6>
            <v-text-field
              v-model="params.weight"
              type="number"
              :label="`${$t('weight')}(kg)`"
              autocomplete="off"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md6 px-2>
        <v-layout px-2>
          <v-flex md4 px-2>
            <v-text-field
              v-model="params.dimentions.x"
              label="X (length)"
              type="number"
              autocomplete="off"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-flex>
          <v-flex md4 px-2>
            <v-text-field
              v-model="params.dimentions.y"
              label="Y (width)"
              type="number"
              autocomplete="off"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-flex>
          <v-flex md4 px-2>
            <v-text-field
              v-model="params.dimentions.z"
              label="Z (height)"
              type="number"
              autocomplete="off"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!--- Inventory --->
    <template #footer>
      <v-card-title>{{ $t("inventory") }}</v-card-title>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ $t("composite_item") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              v-model="params.is_composite_item"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="!params.is_composite_item">
          <v-list-item-content>
            <v-list-item-title>{{ $t("track_stock") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              :readonly="!access.item_edit && (item_id ? true : false)"
              v-model="params.is_track_stock"
            />
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="params.is_composite_item">
          <v-list-item-content>
            <v-list-item-title>{{ $t("use_production") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              :readonly="!access.item_edit && (item_id ? true : false)"
              v-model="params.use_production"
            />
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="params.is_composite_item && params.use_production">
          <v-list-item-content>
            <v-list-item-title>{{
              $t("use_sub_production")
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              :readonly="!access.item_edit && (item_id ? true : false)"
              v-model="params.use_sub_production"
            />
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <!-- track stock -->
      <v-card-text v-if="params.is_track_stock && !params.is_composite_item">
        <v-layout row class="px-2">
          <v-flex md6 class="px-2">
            <v-autocomplete
              v-model="params.primary_supplier_id"
              :label="$t('primary_supplier')"
              v-bind:items="all_suppliers"
              item-text="supplier_name"
              item-value="_id"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-flex>
          <v-flex md4 class="px-2">
            <vuetify-money
              :readonly="!access.item_edit && (item_id ? true : false)"
              v-model="params.default_purchase_cost"
              :label="$t('default_purchase_cost')"
              v-bind:options="
                params.purchase_cost_currency == 'usd'
                  ? moneyOptionsUSD
                  : moneyOptions
              "
            />
          </v-flex>
          <v-flex md2 class="px-2">
            <v-select
              v-model="params.purchase_cost_currency"
              :label="$t('currency')"
              :items="currencies"
              :readonly="!access.item_edit && (item_id ? true : false)"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- composite item -->

      <template v-if="params.is_composite_item">
        <v-data-table
          :mobile-breakpoint="0"
          v-bind:headers="headers"
          v-bind:items="items"
          :items-per-page="200000"
          hide-default-footer
          no-data-text="You have not selected items yet"
        >
          <template #[`item.product_name`]="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.product_name }}</v-list-item-title>
              <v-list-item-subtitle>{{
                item.category_name
              }}</v-list-item-subtitle>
              <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template #[`item.quality`]="{ item }">
            <v-text-field
              v-model="item.quality"
              reverse
              @focus="$event.target.select()"
            />
          </template>
          <template #[`item.sold_by`]="{ item }">
            {{ $t(item.sold_by) }}
          </template>
          <template #[`item.cost`]="{ item }"
            >{{ item.cost ? item.cost.toLocaleString() : 0
            }}{{ item.cost_currency == "usd" ? " $" : "" }}</template
          >
          <template #[`item.remove`]="{ item }">
            <v-btn icon v-on:click="remove_item(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-divider />

        <v-card-text>
          <v-autocomplete
            v-model="composite_item"
            :label="$t('add_item')"
            hide-no-data
            :loading="searching_composite_items"
            v-bind:items="items_list"
            item-text="search_text"
            return-object
            v-on:update:search-input="getCompositeItems"
            v-on:change="add_item"
            :readonly="!access.item_edit && (item_id ? true : false)"
          >
            <template #item="data">
              <v-list-item-content>
                <v-list-item-title>{{
                  data.item.product_name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  data.item.category_name
                }}</v-list-item-subtitle>
                <v-list-item-subtitle
                  >SKU {{ data.item.sku }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
      </template>
      <!-- Variants -->
      <template v-if="!params.is_composite_item">
        <v-card-title>Variants</v-card-title>
        <v-card-text>
          <p v-if="variant_items.length === 0">
            Use variants if an item has different sizes, colors or other options
          </p>
          <div v-else>
            Options:
            <span v-for="(itm, ind) in params.variant_options" :key="ind + 'A'"
              >{{ itm.option_name
              }}{{
                ind !== params.variant_options.length - 1 ? " / " : ""
              }}</span
            >
          </div>
          <div v-if="target === 'update' && is_variant_edit">
            <v-btn
              :disabled="!access.item_edit && (item_id ? true : false)"
              @click="openVariantEditDialog"
              text
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>Edit Options
            </v-btn>
            <v-btn
              :disabled="!access.item_edit && (item_id ? true : false)"
              @click="openVariantDialogDetailRender"
              text
              color="primary"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>Add Variants
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              v-if="variant_items.length == 0"
              @click="openVariantOptionsAdd"
              text
              color="primary"
              :disabled="!access.item_edit && (item_id ? true : false)"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>Add Variants
            </v-btn>
            <v-btn
              :disabled="!access.item_edit && (item_id ? true : false)"
              v-else
              @click="openVariantDialog"
              text
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>Edit Options
            </v-btn>
          </div>
          <v-form v-model="is_valid_variants">
            <v-datadata-table
              v-if="variant_items.length > 0"
              :mobile-breakpoint="0"
              v-bind:items="variant_items"
              v-bind:headers="variants_headers"
              :items-per-page="variant_items_length"
              hide-default-footer
            >
              <template #[`item.name`]="{ item }">
                <div
                  v-if="is_variant_edit"
                  @click="openVariantDialogDetail(item)"
                >
                  {{ item.name }}
                </div>
                <div v-else>{{ item.name }}</div>
              </template>
              <template #[`item.price`]="{ item }">
                <vuetify-money
                  :readonly="!access.item_edit && (item_id ? true : false)"
                  v-model.number="item.price"
                  v-bind:options="
                    item.price_currency == 'usd'
                      ? moneyOptionsUSD
                      : moneyOptions
                  "
                />
              </template>
              <template #[`item.price_currency`]="{ item }">
                <v-select v-model="item.price_currency" :items="currencies" />
              </template>

              <template #[`item.cost`]="{ item }">
                <vuetify-money
                  v-model.number="item.cost"
                  v-bind:options="
                    item.cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions
                  "
                  :readonly="!access.item_edit && (item_id ? true : false)"
                />
              </template>
              <template #[`item.cost_currency`]="{ item }">
                <v-select v-model="item.cost_currency" :items="currencies" />
              </template>

              <template #[`item.sku`]="{ item }">
                <v-text-field
                  v-model="item.sku"
                  type="number"
                  @focus="$event.target.select()"
                  :readonly="!access.item_edit && (item_id ? true : false)"
                />
              </template>

              <template #[`item.is_track_stock`]="{ item }">
                <v-checkbox
                  :readonly="!access.item_edit && (item_id ? true : false)"
                  v-model="item.is_track_stock"
                />
              </template>

              <template #[`item.barcode`]="{ item }">
                <v-combobox
                  :readonly="!access.item_edit && (item_id ? true : false)"
                  v-model="item.barcode"
                  class="ma-0 pa-1"
                  chips
                  multiple
                  :append-icon="null"
                />
              </template>

              <template #[`item.count_by_type`]="{ item }">
                <v-text-field
                  :readonly="!access.item_edit && (item_id ? true : false)"
                  v-model="item.count_by_type"
                  type="number"
                  :ref="'count_by_type' + item.sku"
                  :rules="[fieldRules.require]"
                  @focus="$event.target.select()"
                ></v-text-field>
              </template>

              <template #[`item.remove`]="{ item }">
                <v-btn
                  :disabled="!access.item_edit && (item_id ? true : false)"
                  icon
                  @click="removeVariantItem(item.sku)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>

              <template v-if="variant_items.length > 5" #footer>
                <v-card-title
                  style="cursor: pointer"
                  v-if="variant_items_length == 5"
                  @click="variant_items_length = 1000"
                >
                  <h5 class="font-weight-medium">SHOW ALL VARIANTS</h5>
                  <v-spacer></v-spacer>
                  <v-icon>mdi-chevron-down</v-icon>
                </v-card-title>

                <v-card-title
                  style="cursor: pointer"
                  v-else
                  @click="variant_items_length = 5"
                >
                  <h5>SHOW LESS VARIANTS</h5>
                  <v-spacer></v-spacer>
                  <v-icon>mdi-chevron-up</v-icon>
                </v-card-title>
              </template>
            </v-datadata-table>
          </v-form>

          <v-dialog
            :disabled="!access.item_edit && (item_id ? true : false)"
            v-model="variantDialog"
            width="600"
            persistent
          >
            <v-card>
              <v-card-title>Create options</v-card-title>
              <v-divider />

              <!-- <draggable tag="v-list" handle=".v-list-item__icon"> -->
              <v-list-item
                v-for="(item, index) in variant_options"
                v-bind:key="index"
                v-model="item.value"
              >
                <v-list-item-icon style="margin-right: 10px">
                  <v-icon>mdi-menu</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="ma-0">
                  <v-layout row class="pa-0 ma-0">
                    <v-flex md6 class="ma-0 pa-0 px-1">
                      <v-text-field
                        :readonly="
                          !access.item_edit && (item_id ? true : false)
                        "
                        :rules="[rules.required]"
                        v-model="item.option_name"
                        class="pa-0 ma-0 mt-2"
                        label="Option name"
                        @focus="$event.target.select()"
                      />
                    </v-flex>
                    <v-flex md6 class="ma-0 pa-0 px-1">
                      <v-combobox
                        :rules="[rules.required]"
                        class="pa-0 ma-0"
                        v-model="item.option_values"
                        label="Option value"
                        multiple
                        chips
                        :readonly="
                          !access.item_edit && (item_id ? true : false)
                        "
                      />
                    </v-flex>
                  </v-layout>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    :disabled="!access.item_edit && (item_id ? true : false)"
                    icon
                    @click="removeVariant(index)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <!-- </draggable> -->
              <v-card-text v-if="variant_options.length < 3">
                <v-btn
                  :disabled="!access.item_edit && (item_id ? true : false)"
                  text
                  color="primary"
                  @click="addOptionClicked"
                >
                  <v-icon>mdi-plus-circle-outline</v-icon>add option
                </v-btn>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="cancelVariantClicked">cancel</v-btn>
                <v-btn text @click="addVariantOptions" color="primary"
                  >save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            :readonly="!access.item_edit && (item_id ? true : false)"
            v-model="variantEditDialog"
            width="600"
            persistent
          >
            <v-card>
              <v-card-title>Edit options</v-card-title>
              <v-divider />

              <v-list-item
                v-for="(item, index) in variant_options"
                v-bind:key="index"
                v-model="item.value"
              >
                <v-list-item-content class="ma-0">
                  <v-layout row class="pa-0 ma-0">
                    <v-flex md4 class="ma-0 pa-0 px-1">
                      <v-text-field
                        :rules="[rules.required]"
                        v-model="item.option_name"
                        class="pa-0 ma-0 mt-2"
                        label="Option name"
                        @focus="$event.target.select()"
                        :readonly="
                          !access.item_edit && (item_id ? true : false)
                        "
                      />
                    </v-flex>
                    <v-flex md8 class="ma-0 pa-0 px-3">
                      <v-row>
                        <div
                          v-for="(opt, ind) in item.option_values"
                          :key="ind + 'A'"
                        >
                          <v-chip
                            v-if="item.option_values.includes(opt)"
                            :disabled="
                              !access.item_edit && (item_id ? true : false)
                            "
                            class="mx-1 my-1"
                            close-icon="mdi-close"
                            :close="item.option_values.length > 1"
                            @click:close="removeVariantOptionValue(index, ind)"
                            >{{ opt }}</v-chip
                          >
                        </div>
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  :disabled="!access.item_edit && (item_id ? true : false)"
                  text
                  @click="cancelVariantClicked"
                  >cancel</v-btn
                >
                <v-btn
                  :disabled="!access.item_edit && (item_id ? true : false)"
                  text
                  @click="saveVariantClicked"
                  color="primary"
                >
                  save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </template>
      <!-- Stores -->
      <v-card-title>{{ $t("stores") }}</v-card-title>

      <v-data-table
        :mobile-breakpoint="0"
        v-bind:items="item.services"
        v-bind:headers="services_headers"
        :items-per-page="stores_length"
        hide-default-footer
      >
        <template #[`item.available`]="{ item }">
          <v-checkbox
            :readonly="!access.item_edit && (item_id ? true : false)"
            v-model="item.available"
          />
        </template>
        <template #[`item.price`]="{ item }">
          <vuetify-money
            :readonly="!access.item_edit && (item_id ? true : false)"
            v-model.number="item.price"
            v-bind:options="
              item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions
            "
            @input="item.price_auto_fill = false"
          />
        </template>
        <template #[`item.price_currency`]="{ item }">
          <v-select
            :readonly="!access.item_edit && (item_id ? true : false)"
            v-model="item.price_currency"
            :items="currencies"
          />
        </template>
        <template
          #[`item.in_stock`]="{ item }"
          v-if="params.is_track_stock || params.use_production"
        >
          <v-text-field
            v-model="item.in_stock"
            type="number"
            @focus="$event.target.select()"
            :readonly="!access.item_edit && (item_id ? true : false)"
            :append-icon="'mdi-account-group'"
            @click:append="PartitionGetItem(item)"
          >
          </v-text-field>
        </template>
        <template #[`item.reminder`]="{ item }">
          <v-text-field
            v-model="item.reminder"
            type="number"
            @focus="$event.target.select()"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </template>
        <template
          #[`item.low_stock`]="{ item }"
          v-if="params.is_track_stock || params.use_production"
        >
          <v-text-field
            v-model="item.low_stock"
            type="number"
            @focus="$event.target.select()"
            :readonly="!access.item_edit && (item_id ? true : false)"
          />
        </template>
        <template
          #[`item.optimal_stock`]="{ item }"
          v-if="params.is_track_stock || params.use_production"
        >
          <v-text-field
            v-model="item.optimal_stock"
            type="number"
            :readonly="!access.item_edit && (item_id ? true : false)"
            @focus="$event.target.select()"
          />
        </template>

        <template v-if="item.services.length > 5" #footer>
          <v-card-title
            style="cursor: pointer"
            v-if="stores_length == 5"
            @click="stores_length = 1000"
          >
            <h5 class="font-weight-medium">SHOW ALL STORES</h5>
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-down</v-icon>
          </v-card-title>

          <v-card-title
            style="cursor: pointer"
            v-else
            @click="stores_length = 5"
          >
            <h5>SHOW LESS STORES</h5>
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-up</v-icon>
          </v-card-title>
        </template>
      </v-data-table>
      <!-- Modifiers -->
      <template v-if="modifers.length > 0">
        <v-card-title>Modifiers</v-card-title>
        <v-list>
          <v-list-item
            v-for="(modifier, index) in modifers"
            v-bind:key="index + 'B'"
          >
            <v-list-item-content>
              <v-list-item-title>{{ modifier.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ get_modifier_services(modifier.services) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                :readonly="!access.item_edit && (item_id ? true : false)"
                v-model="modifier_obj[index]"
              />
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
      <!-- Taxes -->
      <template v-if="taxes.length > 0">
        <v-card-title>{{ $t("taxes") }}</v-card-title>
        <v-list>
          <v-list-item v-for="(tax, index) in taxes" v-bind:key="index">
            <v-list-item-content>
              <v-list-item-title>{{ tax.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ get_modifier_services(tax.services) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-switch
                :readonly="!access.item_edit && (item_id ? true : false)"
                v-model="options.taxes[tax._id]"
              />
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
      <!-- Representation -->
      <v-card-title>{{ $t("representation") }}</v-card-title>
      <v-card-text>
        <v-radio-group
          :readonly="!access.item_edit && (item_id ? true : false)"
          row
          v-model="params.representation_type"
        >
          <v-radio
            :readonly="!access.item_edit && (item_id ? true : false)"
            :label="$t('color_and_shape')"
            value="color"
          />
          <v-radio
            :readonly="!access.item_edit && (item_id ? true : false)"
            label="Image"
            value="image"
          />
        </v-radio-group>
        <v-layout>
          <v-flex md8 v-if="params.representation_type == 'color'">
            <v-color-group v-model="params.representation" ref="color_picker" />
            <v-radio-group
              :readonly="!access.item_edit && (item_id ? true : false)"
              row
              v-model="params.shape"
            >
              <v-radio :label="$t('square')" value="square" />
            </v-radio-group>
          </v-flex>
          <v-flex md8 v-else>
            <v-hover #default="{ hover }">
              <v-card
                width="150"
                height="130"
                outlined
                class="text-center"
                :loading="upload_image"
                :class="item.image != '' ? 'pa-0' : hover ? 'py-10' : 'pa-10'"
              >
                <v-icon v-if="item.image == ''" x-large>
                  mdi-image-size-select-actual
                </v-icon>
                <v-img
                  height="125"
                  v-else
                  class="ma-0"
                  :src="params.representation"
                />
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out v-card--reveal pointer"
                  >
                    <v-card
                      block
                      color="primary"
                      dark
                      tile
                      class="d-flex transition-fast-in-fast-out v-card--reveal pointer"
                    >
                      <label
                        class="file-select pointer py-1"
                        style="width: 100%"
                      >
                        Upload
                        <input
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="uploadClicked"
                          :readonly="
                            !access.item_edit && (item_id ? true : false)
                          "
                        />
                      </label>
                    </v-card>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-card-text>
    </template>

    <!-- actions -->
    <template #action>
      <v-btn
        text
        v-on:click="
          target_type === 'composite'
            ? $to('/items/lists/composite')
            : $to('/items/list')
        "
        >{{ $t("cancel") }}
      </v-btn>
      <v-btn
        :disabled="
          (!access.item_edit && (item_id ? true : false)) || saveDisabled
        "
        text
        color="success"
        v-on:click="save"
      >
        {{ $t(target) }}
      </v-btn>
    </template>
    <v-dialog v-model="save_error" width="600">
      <v-card>
        <v-card-title>Save Error</v-card-title>
        <v-card-text>{{ error_message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="save_error = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-variant-detail-dialog
      v-bind:variant_detail_dialog="variant_detail_dialog"
      v-bind:updateItemVariant="itemVariantActionLocal"
      v-bind:createItemVariantActionLocal="createItemVariantActionLocal"
      v-bind:closeVariantDialog="closeVariantDialog"
      v-bind:current_item="current_item"
      v-bind:moneyOptions="moneyOptions"
      v-bind:services_headers="services_headers"
      v-bind:option_names="option_names"
      v-bind:updateServicePrice="updateServicePrice"
      v-bind:disable_save="disable_save"
      v-bind:addVariantLocal="addVariantLocal"
      v-bind:updateVariantLocal="updateVariantLocal"
    />
    <!--Store-->
    <v-dialog v-model="partition_dialog" persistent width="700">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("partition_item") }}</span>
        </v-card-title>
        <v-data-table
          :headers="partition_headers"
          :items="partition_items"
          hide-default-footer
        >
          <template #[`item.quantity`]="{ item }">
            {{ item.quantity }} /{{ item.quantity_left }}
          </template>
          <template #[`item.date`]="{ item }">
            {{ date_ddmmyy_hhmm(item.date) }}
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelPatitionClicked" color="primary"
            >cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text">
          This item has already been added to the list of components
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form-create>
  <error404 v-else></error404>
</template>

<script>
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
import Categories from "../../mixins/items/categories";
import Modifiers from "../../mixins/items/modifiers";
import Taxes from "../../mixins/taxes";
import ItemVariantDialog from "../../mixins/items/item-variant-dialog";
import Currency from "../../mixins/settings/currency";
import Workgroup from "../../mixins/employees/workgroup";
import Features from "../../mixins/features";
import VProgress from "@/components/VProgress/VProgress";
import Organization from "../../mixins/organization";
export default {
  name: "ItemsCreate",
  mixins: [
    Workgroup,
    Services,
    Categories,
    Modifiers,
    Taxes,
    Suppliers,
    ItemVariantDialog,
    Currency,
    Features,
    Organization,
  ],
  components: {
    VProgress,
  },
  data: () => ({
    method_in_process: false,
    hot_key_mask: "A",
    searching_composite_items: false,
    searching_composite_items_mxik: false,
    search_composite_item_text: "123",
    addVariantLocal: false,
    updateVariantLocal: false,
    loading_item_data: false,
    is_valid_variants: false,
    save_error: false,
    item_edit_boolean: false,
    error_message: "sku already exist",
    available_sku: 10000,
    variants_used: 0,
    max: 300,
    modifier_obj: [],
    organization: {},
    rules: {
      required: (value) => !!value || "This field cannot be blank",
    },
    item: {
      services: [],
      variants: [],
      image: "",
      has_variants: false,
      variant_options: [],
      variant_items: [],
    },
    variant_options: [{}],
    variant_items: [],
    variant_items_length: 5,
    stores_length: 5,
    variants_headers: [
      { text: "Variant", value: "name", sortable: false, width: 60 },
      { text: "Price", value: "price", sortable: false },
      { text: "Currency", value: "price_currency", sortable: false },
      { text: "Cost", value: "cost", sortable: false },
      { text: "Currency", value: "cost_currency", sortable: false },
      { text: "SKU", value: "sku", sortable: false },
      { text: "Track Stock", value: "is_track_stock", sortable: false },
      // { text: "Barcode", value: "barcode", sortable: false }
    ],
    variantDialog: false,
    partition_dialog: false,
    variantEditDialog: false,
    is_variant_edit: false,
    upload_image: false,
    active: "top",
    options: {
      modifiers: {},
      taxes: {},
    },
    is_valid: false,
    params: {
      // marking:this.suggestion_item_list_mxik?.label ? true : false,
      description: "",
      primary_supplier_id: null,
      default_purchase_cost: null,
      representation_type: "color",
      composite_item: false,
      show_on_bot: true,
      mxik: "",
      nds_value: null,
      name: null,
      price: null,
      price_currency: "uzs",
      cost: null,
      cost_currency: "uzs",
      purchase_cost_currency: "uzs",
      sku: null,
      barcode: [],
      shape: "square",
      representation: "#E0E0E0",
      use_production: false,
      is_composite_item: false,
      is_track_stock: true,
      is_active: true,
      category: {
        _id: "",
        name: "Other",
      },
      sold_by: "each",
      has_variants: false,
      variant_options: [],
      variant_items: [],
      modifiers: [],
      dimentions: {
        x: null,
        y: null,
        z: null,
      },
    },
    variant_itemsMap: {},
    variant_servcieMap: {},
    map: {},
    headers: [
      { text: "Item", value: "product_name" },
      { text: "Quantity", value: "quality", align: "right" },
      { text: "Sold By", value: "sold_by", align: "center" },
      { text: "Cost", value: "cost", align: "right" },
      { text: null, value: "remove", align: "right", width: 60 },
    ],
    partition_items: [],
    services_headers: [
      { text: "Available", value: "available", sortable: false, width: 60 },
      { text: "Store", value: "service_name", sortable: false },
      { text: "Price", value: "price", sortable: false, width: 200 },
      {
        text: "Currency",
        value: "price_currency",
        sortable: false,
        width: 120,
      },
    ],
    items: [],
    composite_items: [],
    show_on_bot_items: [],
    items_list: [],
    composite_item: null,
    show_on_bot: null,
    all_services: [],
    variant_services: [],
    exist_dialog: false,
    open_barcode: false,
    open_barcode_mxik: false,
    suggestion_item: null,
    suggestion_item_mxik: null,
    suggestion_item_packages: null,
    suggestion_item_list: [],
    suggestion_item_list_mxik: [],
    suggestion_item_list_packages: [],
    searchCategory: null,
    numberRule: (val) => {
      if (val < 0) return "Please enter a positive number";
      return true;
    },
    exampleRules: [
      (v) => v?.length <= 17 || "Max 17 characters",
      (v) => v?.length >= 17 || "Min 17 characters",
    ],
    exampleRulesFalse: [(v) => v?.length <= 17 || "Max 17 characters"],
  }),
  watch: {
    suggestion_item_mxik() {
      this.params.mxik = this.suggestion_item_mxik.mxik;
    },
    suggestion_item() {
      this.params.name = this.suggestion_item.name;
      this.params.sold_by = this.suggestion_item.sold_by;
      this.params.representation = this.suggestion_item.representation;
      this.item.image = this.suggestion_item.representation;
      this.params.brand = this.suggestion_item.brand;
      this.params.representation_type =
        this.suggestion_item.representation_type;
    },
    "params.sku"() {
      if (this.params.sku) {
        this.params.sku += "";
        this.params.sku = this.params.sku.replace(/[^0-9]/i, "");
      }
    },
    "params.composite_item"() {
      if (this.item && typeof this.item.services === typeof []) {
        for (const ind in this.item.services) {
          this.item.services[ind].available = !this.params.composite_item;
        }
      }
    },
    // "params.show_on_bot"() {
    //   if (this.item && typeof this.item.services === typeof []) {
    //     for (const ind in this.item.services) {
    //       this.item.services[ind].available = !this.params.show_on_bot;
    //     }
    //   }
    // },
    "params.is_composite_item"() {
      if (!this.params.is_composite_item) {
        this.params.use_production = false;
      } else {
        this.params.is_track_stock = false;
      }
    },
    "params.use_sub_production"() {
      this.getCompositeItems(this.search_composite_item_text, true);
    },
    "params.use_production"() {
      if (!this.params.use_production) {
        this.params.use_sub_production = false;
      }
    },
    "params.sold_by"() {
      if (this.target === "create") {
        if (this.params.sold_by === "weight") {
          this.getWeightAvailableSku();
        } else {
          this.getAvailableSku();
        }
      }
      const headers = [];
      for (const h of this.variants_headers) {
        if (h.value === "sku" && this.params.sold_by === "pcs") {
          headers.push({
            text: this.$t("count_by_type"),
            value: "count_by_type",
            sortable: false,
            width: 120,
          });
        } else if (h.value !== "count_by_type") {
          headers.push(h);
        }
      }
      this.variants_headers = headers;
    },
    modifier_obj: {
      deep: true,
      handler() {
        var params_modifiers = [];
        for (let i = 0; i < this.modifier_obj.length; i++) {
          if (this.modifier_obj[i]) {
            params_modifiers.push(this.modifers[i]._id);
          }
        }
        this.params.modifiers = params_modifiers;
      },
    },
    variant_items: {
      deep: true,
      handler() {
        if (this.variant_items.length > 0) {
          const variant_headers_length =
            this.params && this.params.sold_by == "pcs" ? 8 : 7;
          const headers = [];
          for (const h of this.variants_headers) {
            if (
              this.is_variant_edit &&
              this.variants_headers.length == variant_headers_length &&
              this.variant_items.length < 2 &&
              h.value != "remove"
            ) {
              headers.push(h);
            } else if (h.value != "remove") {
              headers.push(h);
            }
          }
          this.variants_headers = headers;
          this.setServiceVariants();
        }
      },
    },
    "item.services": {
      deep: true,
      handler() {
        if (this.variant_items.length > 0) {
          this.itemServiceChanged();
        }
      },
    },
    "params.price"() {
      if (
        !this.is_variant_edit &&
        (this.target === "create" || this.params.price)
      ) {
        for (const index in this.item.services) {
          if (this.item.services[index].price_auto_fill !== false) {
            if (this.target === "create") {
              this.item.services[index].price = this.params.price;
            } else if (!this.item.services[index].price) {
              this.item.services[index].price = this.params.price;
            }
          }
        }
        this.all_services = JSON.parse(JSON.stringify(this.item.services));
      }
    },
    "params.price_currency"() {
      if (
        !this.is_variant_edit &&
        this.target === "create" &&
        this.item &&
        typeof this.item.services === typeof []
      ) {
        for (const index in this.item.services) {
          this.item.services[index].price_currency = this.$copy(
            this.params.price_currency
          );
        }
        this.all_services = JSON.parse(JSON.stringify(this.item.services));
      }
    },
    services: {
      deep: true,
      handler() {
        if (!this.is_variant_edit && this.target === "create") {
          this.item.services = [];
          for (const index in this.services) {
            this.item.services.push({
              service: this.services[index]._id,
              available: true,
              in_stock: 0,
              service_name: this.services[index].name,
              price: 0,
              price_currency: "uzs",
            });
          }
          this.all_services = this.item.services;
        }
      },
    },
    taxes: {
      deep: true,
      handler() {
        for (const index in this.taxes) {
          this.options.taxes[this.taxes[index]._id] = false;
        }
      },
    },
    items: {
      deep: true,
      handler() {
        let cost = 0;
        for (let item in this.items) {
          item = this.$copy(item);
          let item_cost = +item.cost;
          if (+item.quality * item_cost) {
            if (
              item.cost_currency === "usd" &&
              this.currency &&
              this.currency.value
            ) {
              item_cost = item_cost * this.currency.value;
            }
            cost += +item.quality * item_cost;
          }
        }
        if (cost && this.params.is_composite_item) {
          if (
            this.params.cost_currency === "usd" &&
            this.currency &&
            this.currency.value
          ) {
            cost = cost / this.currency.value;
          }
          this.params.cost = cost;
        }
      },
    },
    "params.cost_currency"() {
      if (this.params.is_composite_item) {
        let cost = 0;
        for (let item of this.items) {
          item = this.$copy(item);
          let item_cost = +item.cost;
          if (+item.quality * item_cost) {
            if (
              item.cost_currency === "usd" &&
              this.currency &&
              this.currency.value
            ) {
              item_cost = item_cost * this.currency.value;
            }
            cost += +item.quality * item_cost;
          }
        }
        if (cost && this.params.is_composite_item) {
          if (
            this.params.cost_currency === "usd" &&
            this.currency &&
            this.currency.value
          ) {
            cost = cost / this.currency.value;
          }
          this.params.cost = cost;
        }
      }
    },
    params: {
      deep: true,
      handler() {
        if (this.params.is_track_stock || this.params.use_production) {
          this.services_headers = [
            {
              text: this.$t("available"),
              value: "available",
              sortable: false,
              width: 60,
            },
            { text: this.$t("store"), value: "service_name", sortable: false },
          ];
          if (this.params.has_variants && !this.params.is_composite_item) {
            this.services_headers.push({
              text: this.$t("variant"),
              value: "variant_name",
              sortable: false,
            });
          }
          this.services_headers = this.services_headers.concat([
            { text: this.$t("price"), value: "price", sortable: false },
            {
              text: this.$t("currency"),
              value: "price_currency",
              sortable: false,
              width: 120,
            },
            { text: this.$t("in_stock"), value: "in_stock", sortable: false },
          ]);
          if (
            this.params &&
            (this.params.sold_by === "box" || this.params.sold_by === "pcs")
          ) {
            this.services_headers.push({
              text: this.$t("reminder"),
              value: "reminder",
              sortable: false,
            });
          }
          this.services_headers = this.services_headers.concat([
            { text: this.$t("low_stock"), value: "low_stock", sortable: false },
            {
              text: this.$t("optimal_stock"),
              value: "optimal_stock",
              sortable: false,
            },
          ]);
        } else {
          this.services_headers = [
            {
              text: this.$t("available"),
              value: "available",
              sortable: false,
              width: 60,
            },
            { text: this.$t("store"), value: "service_name", sortable: false },
          ];
          if (this.params.has_variants && !this.params.is_composite_item) {
            this.services_headers.push({
              text: this.$t("variant"),
              value: "variant_name",
              sortable: false,
            });
          }
          this.services_headers = this.services_headers.concat([
            {
              text: this.$t("price"),
              value: "price",
              sortable: false,
              width: 200,
            },
            {
              text: this.$t("currency"),
              value: "price_currency",
              sortable: false,
              width: 120,
            },
          ]);
        }
        if (!this.params.dimentions) {
          this.params.dimentions = { x: null, y: null, z: null };
        }
      },
    },
  },
  computed: {
    target() {
      return this.$route.params["target"];
    },
    target_type() {
      return this.$route.params["target_type"];
    },
    item_id() {
      return this.$route.query["id"];
    },
    form() {
      const fObj = {
        name: this.params.name,
        sku: this.params.sku,
      };
      if (this.params.sold_by === "box" || this.params.sold_by == "pcs") {
        fObj[`count_by_type`] = this.params.count_by_type;
      }
      return fObj;
    },
    saveDisabled() {
      let formHasErrors =
        false || this.upload_image || !this.is_valid || !this.is_valid_variants;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    partition_headers() {
      let partition_headers = [
        { text: this.$t("date"), value: "date", sortable: false },
        { text: this.$t("purchase_order"), value: "p_order", sortable: false },
        { text: this.$t("supplier"), value: "supplier_name", sortable: false },
        {
          text: this.$t("in_stock"),
          value: "quantity",
          align: "center",
          sortable: false,
        },
      ];
      return partition_headers;
    },
  },
  methods: {
    closeBarcodeDialog() {
      this.open_barcode = false;
    },
    closeBarcodeDialogMxik() {
      this.open_barcode_mxik = false;
    },
    itemSearchBarcode() {
      this.open_barcode = true;
    },

    itemSearchBarcodeMxik() {
      if(this.params.mxik){
        this.open_barcode_mxik = true;
      }
      // this.suggestion_item_list_mxik = [];
      // this.suggestion_item_list_packages = [];

      // this.$communicator.getFromTasnif(this.params.mxik).then((res) => {
      //   (this.params.mxik = res.data.data[0].mxik),

      //   this.suggestion_item_list_mxik = [
      //     {
      //       mxik: res.data.data[0].mxik,
      //       mxikName: res.data.data[0].name,
      //       total: res.data.recordTotal,
      //       label: res.data.data[0]?.label > 0 ? true : false,
      //     },
      //   ];

      //   this.suggestion_item_list_packages = [...res.data.data[0].packages];
      // });
    },
    itemSearchBarcodeMxikInput() {
      const time = 500;
      setTimeout(() => {
        if (this.params.mxik.length === 17) {
          this.itemSearchBarcodeMxik();
        }
      }, time);
    },
    async PartitionGetItem(item) {
      this.partition_dialog = true;
      const link = `items/partiation/${this.$route.query["id"]}`;
      const result = await this.$communicator.postMethod2(link, {
        service_id: item.service,
      });
      this.partition_items = result.data?.data;
    },
    cancelPatitionClicked() {
      this.partition_dialog = false;
    },
    async getWeightAvailableSku() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("get_weight_available_sku", {
          params: {
            used_skus: [],
          },
        })
      );
      if (result) {
        this.params.sku = result.sku;
      }
    },
    async getAvailableSku() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("get_available_sku")
      );
      if (result) {
        this.params.sku = result.sku;
      }
    },
    async getCompositeItems(search, watched = false) {
      if (!search) {
        search = "";
      }
      if (
        (this.search_composite_item_text != search &&
          typeof search == typeof "") ||
        watched
      ) {
        this.searching_composite_items = true;
        const res = this.$communicator.then(
          this,
          await this.$communicator("list_of_items", {
            arguments: [50, 1],
            params: {
              name: search,
              use_sub_production:
                this.params && this.params.use_sub_production == true,
            },
          })
        );
        if (res && res.data) {
          const items = res.data;
          var items_list = [];
          for (const index in items) {
            if (
              this.target === "create" ||
              (this.target === "update" &&
                this.$route.query["id"] !== items[index]._id)
            ) {
              let search_text =
                items[index].name +
                items[index].category_name +
                items[index].sku;
              if (typeof items[index].barcode === typeof []) {
                for (const b of items[index].barcode) {
                  search_text += b;
                }
              }
              items_list.push({
                product_id: items[index]._id,
                product_name: items[index].name,
                category_name: items[index].category_name,
                sold_by: items[index].sold_by,
                cost: items[index].cost,
                cost_currency: items[index].cost_currency,
                quality: 0,
                sku: items[index].sku,
                search_text: search_text,
              });
            }
          }
          this.items_list = items_list;
        }
        this.search_composite_item_text = search;
      }
      this.searching_composite_items = false;
    },
    async itemSearchGetBarcode(search) {
      if (!search) {
        search = "";
      }
      this.searching_composite_items = true;
      const res = this.$communicator.then(
        this,
        await this.$communicator("suggestion_items_name", {
          query: {
            barcode: this.params?.barcode[0] ? this.params?.barcode[0] : search,
            limit: 10,
            page: 1,
          },
        })
      );
      if (res.statusCode == 422 || res.total == 0) {
        this.$toast.error("Items not found of this barcode", { timeout: 3000 });
        this.closeBarcodeDialog();
      } else if (res && res.data) {
        this.suggestion_item_list = res.data;
        this.params.name = res.data[0]?.name;
        this.suggestion_item = res.data[0]
      }

      this.searching_composite_items = false;
    },
    async itemSearchGetBarcodeMxik(by = "mxik") {
      this.suggestion_item_list_mxik = [];
      this.suggestion_item_list_packages = [];
      this.searching_composite_items_mxik = true;
      if((this.params.mxik !="" && by != "barcode") || (this.params.barcode?.length > 0 && by === "barcode")){
        const params = {};
        if(by === "barcode"){
          params.shtrixCode = this.params.barcode[0];
          this.itemSearchBarcode()
        } else {
          params.mxikCode = this.params.mxik
        }
      await this.$communicator
        .getFromTasnif(params)
        .then((res) => {
          (this.params.mxik = res.data.data[0]?.mxik),
            (this.suggestion_item_list_mxik = [
              {
                mxik: res.data.data[0]?.mxik,
                mxikName: res.data.data[0]?.name,
                total: res.data.recordTotal,
                label: res.data.data[0]?.label > 0 ? true : false,
              },
            ]);

          this.suggestion_item_list_packages = [...res?.data?.data[0]?.packages];
          if(res?.data?.data[0]?.packages?.length && !this.suggestion_item_packages) {
            this.suggestion_item_packages = res?.data?.data[0]?.packages[0]
          }
        })
        .catch((e) => {
          this.params.mxik = null;
          this.suggestion_item_mxik = null;
          this.suggestion_item_packages = null
          this.$toast.error("Mxik not found", {
            timeout: 3000,
          });
          this.suggestion_item_list_packages = [];
          this.closeBarcodeDialogMxik();
          throw e
        });
      }
      // const res = this.$communicator.then(
      //   this,
      //   await this.$communicator("suggestion_items_mxik", {
      //     query: {
      //       barcode: this.params?.barcode[0] ? this.params?.barcode[0] : search,
      //       limit: 10,
      //       page: 1,
      //     },
      //   }).catch(() => {
      //     this.$toast.error("Time out", {
      //       timeout: 3000,
      //     });
      //     this.closeBarcodeDialogMxik();
      //   })
      // );
      // if (res.statusCode == 422 || res.total == 0) {

      //   this.$toast.error("Items not found of this barcode", { timeout: 3000 });
      //   this.closeBarcodeDialogMxik();
      // } else if (res && res.data) {
      //   this.suggestion_item_list_mxik = res?.data;
      // }
      this.searching_composite_items_mxik = false;
    },
    setServiceVariants() {
      if (!this.is_variant_edit) {
        const services = [];
        if (this.variant_items?.length === 0) {
          for (const service of this.services) {
            services.push({
              service: service._id,
              service_name: service.name,
              price: this.params.price,
              // price_changed: false,
              in_stock: 0,
              available: true,
              variant_name: name,
            });
          }
          this.params.services = services;
          this.item.services = JSON.parse(JSON.stringify(services));
          this.params.has_variants = false;
        } else {
          this.params.has_variants = true;
          const used_sku = [];
          const variant_itemsMap = this.variant_itemsMap;
          for (const variant_item of this.variant_items) {
            used_sku.push(variant_item.sku);
            if (variant_itemsMap[variant_item.sku] === undefined) {
              variant_itemsMap[variant_item.sku] = {
                ...variant_item,
                services: this.services,
              };
            } else {
              delete variant_item.services;
              variant_itemsMap[variant_item.sku] = {
                ...variant_itemsMap[variant_item.sku],
                ...variant_item,
              };
            }
          }
          const all_sku = Object.keys(variant_itemsMap);
          for (const sku of all_sku) {
            const SKU = +sku;
            if (!used_sku.includes(SKU)) {
              delete variant_itemsMap[SKU];
            } else {
              for (const ser of variant_itemsMap[SKU].services) {
                // if (ser.price_changed == false) {
                //   ser.price = variant_itemsMap[SKU].price;
                // }
                if (ser.price_auto_fill !== false) {
                  ser.price = variant_itemsMap[SKU].price;
                }
                ser.sku = SKU;
                services.push(ser);
              }
            }
          }
          this.item.services = JSON.parse(JSON.stringify(services));
          this.variant_itemsMap = variant_itemsMap;
        }
      } else {
        const services = [];
        const serviceObj = {};
        for (const s of this.item.services) {
          if (!serviceObj[s.service + s.sku]) {
            serviceObj[s.service + s.sku] = s;
          }
        }
        for (const variant_item of this.variant_items) {
          for (const ser of variant_item.services) {
            if (serviceObj[ser.service + variant_item.sku] !== undefined) {
              let old_service = serviceObj[ser.service + variant_item.sku];
              services.push({
                ...ser,
                sku: variant_item.sku,
                variant_name: variant_item.name,
                price:
                  old_service.price_auto_fill !== false
                    ? variant_item.price
                    : old_service.price,
                price_currency:
                  old_service.price_auto_fill !== false
                    ? variant_item.price_currency
                    : ser.price_currency,
                price_auto_fill: old_service.price_auto_fill,
              });
            } else {
              services.push({
                ...ser,
                sku: variant_item.sku,
                variant_name: variant_item.name,
                price:
                  ser.price_auto_fill !== false
                    ? variant_item.price
                    : ser.price,
                price_currency:
                  ser.price_auto_fill !== false
                    ? variant_item.price_currency
                    : ser.price_currency,
              });
            }
          }
        }
        this.item.services = JSON.parse(JSON.stringify(services));
      }
    },
    itemServiceChanged() {
      /*
      if (!this.is_variant_edit) {
        if (typeof this.item.services == typeof []) {
          for (let i = 0; i < this.item.services.length; i++) {
            if (
              this.item.services[i].sku &&
              this.variant_itemsMap[this.item.services[i].sku]
            ) {
              for (
                let j = 0;
                j <
                this.variant_itemsMap[this.item.services[i].sku].services
                  .length;
                j++
              ) {
                const service = this.variant_itemsMap[this.item.services[i].sku]
                  .services[j];
                if (!this.item.services[i].price) {
                  this.item.services[i].price = 0;
                }
                if (!service.price) {
                  service.price = 0;
                }
                if (
                  service.service + "" == this.item.services[i].service + "" &&
                  this.item.services[i].price != service.price &&
                  service.variant_name == this.item.services[i].variant_name
                ) {
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].price_changed = true;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].price = this.item.services[i].price;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].in_stock = this.item.services[i].in_stock;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].low_stock = this.item.services[i].low_stock;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].optimal_stock = this.item.services[i].optimal_stock;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].available = this.item.services[i].available;
                  break;
                } else if (
                  service.service + "" == this.item.services[i].service + "" &&
                  service.variant_name == this.item.services[i].variant_name
                ) {
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].in_stock = this.item.services[i].in_stock;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].low_stock = this.item.services[i].low_stock;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].optimal_stock = this.item.services[i].optimal_stock;
                  this.variant_itemsMap[this.item.services[i].sku].services[
                    j
                  ].available = this.item.services[i].available;
                }
              }
            }
          }
        }
      }
      */
    },
    addVariantOptions() {
      const names = [];
      // variant_itemsMap
      const variant_options = [];
      for (const index in this.variant_options) {
        variant_options.push({
          option_name: this.variant_options[index].option_name,
          option_values: this.variant_options[index].option_values,
        });
      }
      let sku = this.available_sku + 1;
      for (let i = 0; i < variant_options.length; i++) {
        for (let k = 0; k < variant_options[i].option_values.length; k++) {
          if (variant_options.length > 1) {
            for (let j = i + 1; j < variant_options.length; j++) {
              for (
                let p = 0;
                p < variant_options[j].option_values.length;
                p++
              ) {
                if (variant_options.length > 2) {
                  for (let q = j + 1; q < variant_options.length; q++) {
                    for (
                      let r = 0;
                      r < variant_options[q].option_values.length;
                      r++
                    ) {
                      names.push(
                        variant_options[i].option_values[k] +
                          " / " +
                          variant_options[j].option_values[p] +
                          " / " +
                          variant_options[q].option_values[r]
                      );
                    }
                  }
                } else {
                  names.push(
                    variant_options[i].option_values[k] +
                      " / " +
                      variant_options[j].option_values[p]
                  );
                }
              }
            }
          } else {
            names.push(variant_options[i].option_values[k]);
          }
        }
      }
      const variant_items = [];
      for (const name of names) {
        if (this.variant_itemsMap[sku]) {
          this.variant_itemsMap[sku].name = name;
        } else {
          let services = [];
          for (const service of this.services) {
            services.push({
              service: service._id,
              service_name: service.name,
              price: this.params.price ? this.params.price : 0,
              price_currency: this.params.price_currency
                ? this.params.price_currency
                : "uzs",
              // price_changed: false,
              in_stock: 0,
              variant_name: name,
              available: true,
            });
          }
          this.variant_itemsMap[sku] = {
            name: name,
            cost: this.params.cost ? this.params.cost : 0,
            price: this.params.price ? this.params.price : 0,
            barcode: [],
            services: services,
          };
        }
        variant_items.push({
          ...this.variant_itemsMap[sku],
          sku: sku,
          is_track_stock: this.params.is_track_stock,
          price_currency: this.params.price_currency,
          cost_currency: this.params.cost_currency,
          services: undefined,
        });
        sku++;
      }
      this.params.variant_options = variant_options;
      this.variant_items = variant_items;
      this.variantDialog = false;
    },
    openVariantOptionsAdd() {
      this.variantDialog = true;
    },
    openVariantDialog() {
      this.variantDialog = true;
      if (
        (this.params &&
          this.params.variant_options &&
          this.params.variant_options.length === 0) ||
        (this.params && !this.params.variant_options)
      ) {
        this.variant_options = [{}];
      } else {
        this.variant_options = JSON.parse(
          JSON.stringify(this.params.variant_options)
        );
      }
    },
    openVariantEditDialog() {
      // for(let i=0; i<)
      this.variantEditDialog = true;
      // if (
      //   (this.params &&
      //     this.params.variant_options &&
      //     this.params.variant_options.length == 0) ||
      //   (this.params && !this.params.variant_options)
      // ) {
      //   this.variant_options = [{}];
      // } else {
      //   this.variant_options = JSON.parse(
      //     JSON.stringify(this.params.variant_options)
      //   );
      // }
    },
    cancelVariantClicked() {
      this.variantDialog = false;
      this.variantEditDialog = false;
      this.variant_options = [];
    },

    saveVariantClicked() {
      if (this.variant_options && this.variant_options.length > 0) {
        this.params.variant_options = JSON.parse(
          JSON.stringify(this.variant_options)
        );
        var variant_items = [];
        for (let i = 0; i < this.variant_options.length; i++) {
          for (
            let k = 0;
            k < this.variant_options[i].option_values.length;
            k++
          ) {
            if (this.variant_options.length > 1) {
              for (let j = i + 1; j < this.variant_options.length; j++) {
                for (
                  let p = 0;
                  p < this.variant_options[j].option_values.length;
                  p++
                ) {
                  if (this.variant_options.length > 2) {
                    for (let q = j + 1; q < this.variant_options.length; q++) {
                      for (
                        let r = 0;
                        r < this.variant_options[q].option_values.length;
                        r++
                      ) {
                        variant_items.push({
                          name:
                            this.variant_options[i].option_values[k] +
                            " / " +
                            this.variant_options[j].option_values[p] +
                            " / " +
                            this.variant_options[q].option_values[r],
                        });
                        if (
                          !this.variant_itemsMap[
                            this.variant_options[i].option_values[k] +
                              " / " +
                              this.variant_options[j].option_values[p] +
                              " / " +
                              this.variant_options[q].option_values[r]
                          ]
                        ) {
                          this.variant_itemsMap[
                            this.variant_options[i].option_values[k] +
                              " / " +
                              this.variant_options[j].option_values[p] +
                              " / " +
                              this.variant_options[q].option_values[r]
                          ] = variant_items[variant_items.length - 1];
                        }
                      }
                    }
                  } else {
                    variant_items.push({
                      name:
                        this.variant_options[i].option_values[k] +
                        " / " +
                        this.variant_options[j].option_values[p],
                    });
                    if (
                      !this.variant_itemsMap[
                        this.variant_options[i].option_values[k] +
                          " / " +
                          this.variant_options[j].option_values[p]
                      ]
                    ) {
                      this.variant_itemsMap[
                        this.variant_options[i].option_values[k] +
                          " / " +
                          this.variant_options[j].option_values[p]
                      ] = variant_items[variant_items.length - 1];
                    }
                  }
                }
              }
            } else {
              variant_items.push({
                name: this.variant_options[i].option_values[k],
              });
              if (
                this.variant_itemsMap[this.variant_options[i].option_values[k]]
              ) {
                this.variant_itemsMap[
                  this.variant_options[i].option_values[k]
                ] = variant_items[variant_items.length - 1];
              }
            }
          }
        }
        if (variant_items.length > 0) {
          this.params.has_variants = true;
        }
        let sku = this.params.sku + 1;
        if (this.target !== "create") {
          sku = this.available_sku + 1;
        }
        for (let i = 0; i < variant_items.length; i++) {
          variant_items[i].price = this.params.price;
          variant_items[i].cost = this.params.cost;
          variant_items[i].sku = sku++;
          variant_items[i].barcode = [];
        }
        this.variant_items = variant_items;
      } else {
        this.params.has_variants = false;
        this.item.variants = [];
      }
      this.variantDialog = false;
      this.variantEditDialog = false;
    },
    removeVariant(ind) {
      var variant_options = [];
      for (let i = 0; i < this.variant_options.length; i++) {
        if (ind != i) {
          variant_options.push(this.variant_options[i]);
        }
      }
      this.variant_options = variant_options;
    },
    removeVariantItem(sku) {
      var variant_items = [];
      var names = {};
      for (let i = 0; i < this.variant_items.length; i++) {
        if (this.variant_items[i].sku !== sku) {
          variant_items.push(this.variant_items[i]);
          let arr = this.variant_items[i].name.split(" / ");
          for (let j = 0; j < arr.length; j++) {
            names[arr[j]] = true;
          }
        }
      }
      if (variant_items.length === 0) {
        this.params.variant_options = [];
        this.params.has_variants = false;
      }
      this.variant_items = variant_items;
      for (let i = 0; i < this.params.variant_options.length; i++) {
        var option_values = [];
        for (
          let j = 0;
          j < this.params.variant_options[i].option_values.length;
          j++
        ) {
          if (names[this.params.variant_options[i].option_values[j]]) {
            option_values.push(this.params.variant_options[i].option_values[j]);
          }
        }
        this.params.variant_options[i].option_values = option_values;
      }
    },
    removeVariantOptionValue(index, ind) {
      const variant_options = [];
      for (let i = 0; i < this.variant_options.length; i++) {
        const option_values = [];
        for (let j = 0; j < this.variant_options[i].option_values.length; j++) {
          if (i !== index || j !== ind) {
            option_values.push(this.variant_options[i].option_values[j]);
          }
        }
        variant_options.push({
          ...this.variant_options[i],
          option_values: option_values,
        });
      }
      this.variant_options = variant_options;
    },
    addOptionClicked() {
      const variant_options = [];
      for (const index in this.variant_options) {
        variant_options.push({
          option_name: this.variant_options[index].option_name,
          option_values: this.variant_options[index].option_values,
        });
      }
      this.variant_options = variant_options;
      if (this.variant_options.length < 3) {
        this.variant_options.push({});
      }
    },
    openVariantDialogDetailRender() {
      this.addVariantLocal = true;
      let current_item = {
        services: [],
        cost: this.params.cost ? this.params.cost : 0,
      };
      for (const ser of this.services) {
        current_item.services.push({
          available: true,
          in_stock: 0,
          price: this.params.price,
          price_currency: this.params.price_currency,
          low_stock: 0,
          optimal_stock: 0,
          service: ser._id,
          service_name: ser.name,
        });
      }
      current_item = {
        is_track_stock: this.params.is_track_stock,
        price: this.params.price,
        price_currency: this.params.price_currency
          ? this.params.price_currency
          : "uzs",
        cost: this.params.cost,
        cost_currency: this.params.cost_currency
          ? this.params.cost_currency
          : "uzs",
        default_purchase_cost: this.params.default_purchase_cost,
        purchase_cost_currency: this.params.purchase_cost_currency
          ? this.params.purchase_cost_currency
          : "uzs",
        sku: this.available_sku,
        services: current_item.services,
        variant_options: this.params.variant_options,
      };
      this.openVariantDialogDetail(current_item);
    },
    async uploadClicked(e) {
      this.upload_image = true;
      if (e && e.target && e.target.files && e.target.files[0]) {
        this.image_loading = true;
        try {
          var res = await this.$communicator.file(
            "upload",
            {
              file: e.target.files[0],
            },
            true
          );
          this.params.representation =
            `${this.$communicator.base_url}static/` + res.data.data.path;
          this.item.image = this.params.representation;
          this.upload_image = false;
        } catch (err) {
          this.upload_image = false;
          throw err;
        }
      }
    },
    add_item() {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id === this.composite_item.product_id) {
          exist = true;
        } else if (itm.product_id === this.show_on_bot_items.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push(this.$copy(this.composite_item));
      }
      this.composite_item = {
        name: null,
      };
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    get_modifier_services(services) {
      var result = [];
      for (const index in services) {
        result.push(services[index].service_name);
      }
      return result.join(", ");
    },
    activate(items) {
      if (items.length > 0) {
        this.active = items[items.length - 1];
        if (!this.map[this.active]) {
          for (const categ of this.all_plus_children_categories) {
            if (categ.children.length > 0) {
              for (const child of categ.children) {
                if (child._id === this.active) {
                  this.map[this.active] = {
                    id: child._id,
                    name: child.name,
                    type: child.type,
                  };
                }
              }
            }
            if (categ._id === this.active) {
              this.map[this.active] = {
                id: categ._id,
                name: categ.name,
                type: categ.type,
              };
            }
          }
        }
        if (this.map[this.active]) {
          this.params.category = { name: this.map[this.active].name };
          this.searchCategory = this.params.category.name;
        }
      }
    },
    route(categories) {
      for (const index in categories) {
        this.map[categories[index]._id] = {
          id: categories[index]._id,
          name: categories[index].name,
          type: categories[index].type,
        };
        if (categories[index].children.length > 0) {
          this.route(categories[index].children);
        }
      }
    },
    async refresh() {
      if (this.target === "update") {
        const id = this.$route.query["id"];
        if (this.map[id]) {
          this.params.name = this.map[id].name;
          if (this.map[this.map[id].type]) {
            this.active = this.map[this.map[id].type]._id;
            this.params.category.name = this.map[this.map[id].type].name;
          }
        }
      }
    },
    async update() {
      let item = {};
      if (this.target === "update") {
        item = this.$communicator.then(
          this,
          await this.$communicator("get_item_by_id", {
            arguments: [this.$route.query["id"]],
          })
        );
        if (item) {
          this.suggestion_item_list_packages = [];
          this.params = item;
          this.params.category = { name: item.category_name };
          this.searchCategory = item.category_name;
          this.items = this.params.composite_items;
          // this.items = this.params.show_on_bot;
          // this.items = this.params.marking;
          if (this.params?.package_code && this.params?.package_name) {
            this.suggestion_item_list_packages = [
              {
                code: this.params?.package_code,
                nameUz: this.params?.package_name,
              },
            ];
          }

          this.suggestion_item_packages = this.suggestion_item_list_packages[0];
          this.is_variant_edit = item.has_variants;
          const variant_headers_length = this.params.sold_by === "pcs" ? 8 : 7;
          const headers = [];
          for (const h of this.variants_headers) {
            if (
              this.is_variant_edit &&
              this.variants_headers.length === variant_headers_length &&
              this.variant_items.length < 2 &&
              h.value !== "remove"
            ) {
              headers.push(h);
            } else if (h.value !== "remove") {
              headers.push(h);
            }
          }
          this.variants_headers = headers;
          if (this.is_variant_edit) {
            const variant_items = [];
            for (const vitem of item.variant_items) {
              variant_items.push({
                ...vitem,
                variant_name: vitem.name,
              });
            }
            this.variant_items = JSON.parse(JSON.stringify(variant_items));
            this.item.services = JSON.parse(
              JSON.stringify(item.variant_services)
            );
          } else {
            this.item.services = this.$copy(item.services);
          }
        }
      }
      const sku = this.$communicator.then(
        this,
        await this.$communicator("get_available_sku")
      );
      this.available_sku = sku.sku;
      if (this.target === "create") {
        if (sku) {
          this.params.sku = sku.sku;
        }
      } else {
        if (item && item.modifiers && item.modifiers.length > 0) {
          for (let i = 0; i < this.modifers.length; i++) {
            if (item.modifiers.includes(this.modifers[i]._id)) {
              this.modifier_obj[i] = true;
            }
          }
        }
        if (item && item.representation_type === "image") {
          this.item.image = item.representation;
        }
        if (item) {
          if (item.variant_options) {
            this.variant_options = item.variant_options;
          }
          // set defaults
          item.variant_options = item.variant_options
            ? item.variant_options
            : [];
          item.variant_services = item.variant_services
            ? item.variant_services
            : [];
          item.barcode =
            item.barcode === ""
              ? []
              : typeof item.barcode === typeof "invan"
              ? [item.barcode]
              : item.barcode;
          this.params = this.$copy(item);
          this.variant_items = item.variant_items ? item.variant_items : [];
          for (let i = 0; i < this.variant_items.length; i++) {
            if (this.variant_items[i].barcode === "") {
              this.variant_items[i].barcode = [];
            } else if (
              typeof this.variant_items[i].barcode === typeof "invan"
            ) {
              this.variant_items[i].barcode = [this.variant_items[i].barcode];
            }
          }
          if (this.params.representation_type === "color") {
            this.$refs["color_picker"]?.init(this.params.representation) ?? "";
          }
          if (typeof item.taxes === typeof []) {
            for (const index in item.taxes) {
              this.options["taxes"][item.taxes[index].tax_id] =
                item.taxes[index].available;
            }
          }
          if (!this.is_variant_edit) {
            var item_services = [];
            for (const index in item.services) {
              item_services.push({
                service: item.services[index].service,
                available: item.services[index].available,
                in_stock: item.services[index].in_stock,
                service_name: item.services[index].service_name,
                price: item.services[index].price,
                price_currency: item.services[index].price_currency,
              });
            }
            // this.item.services = item_services;
            this.all_services = this.$copy(item_services);
          }
        }
      }
      this.loading_item_data = false;
    },
    async save() {
      await this.itemSearchGetBarcodeMxik("mxik");
      if(!this.suggestion_item_packages?.code && this.organization.is_ofd ){
        this.$toast.error("Package code not found", {
            timeout: 3000,
          });
        throw null
      }
      this.method_in_process = true;
      var taxes = [];
      for (const id in this.options["taxes"]) {
        taxes.push({
          tax_id: id,
          available: this.options["taxes"][id],
        });
      }
      var params = {
        ...this.params,
        services: this.$copy(this.item.services),
        taxes,
        composite_items: this.items,
        show_on_bot_items: this.items,
        package_code: this.suggestion_item_packages?.code,
        marking: this.suggestion_item_list_mxik[0]?.label,
        package_name: this.suggestion_item_packages?.nameUz,
      };
      var category = this.$copy(params.category);
      delete params["category"];
      params.category_name = category.name;
      params.category = category._id;
      params.variant_items = this.variant_items;
      var route, result;
      if (this.target === "create") {
        route = "create_item";
        if (this.params.has_variants) {
          route = "create_item_variant";
        }
        try {
          result = await this.$communicator(route, {
            params,
          });
          if (result?.data.statusCode == 200) {
            this.$toast.success(`${result?.data?.message}`, { timeout: 2000 });
          } else {
            this.$toast.error(`${result?.data?.message}`, { timeout: 2000 });
          }
          this.method_in_process = false;
        } catch (err) {
          this.method_in_process = false;
          this.save_error = true;
          this.error_message = "Could not save";
        }
      } else {
        route = "update_item";
        if (this.params.has_variants) {
          route = "update_item_variant";
        }
        try {
          result = await this.$communicator(route, {
            arguments: [this.$route.query["id"]],
            params,
          });
          if (result?.data.statusCode == 200) {
            this.$toast.success(`${result?.data?.message}`, { timeout: 2000 });
          } else {
            this.$toast.error(`${result?.data?.message}`, { timeout: 2000 });
          }
        } catch (err) {
          this.save_error = true;
          this.error_message = "Could not save";
        }
        // this.$router.push({ path: "/items/list" });
      }
      if (result && result.data && result.data.statusCode === 200) {
        if (this.target_type === "composite") {
          this.$router.push({ path: "/items/lists/composite" });
        } else if (this.target_type === "show_on_bot") {
          this.$router.push({ path: "/items/lists/store" });
        } else {
          this.$router.push({ path: "/items/list" });
        }
      } else if (result && result.data && result.data.statusCode == 411) {
        this.save_error = true;
        this.error_message = "Sku or Hot key allready exist";
      } else if (result && result.data && result.data.statusCode == 412) {
        this.save_error = true;
        this.error_message = "Barcode allready exist";
      } else {
        this.save_error = true;
        this.error_message = "Item Could not saved";
      }
    },
    changePackages(option){
      this.suggestion_item_packages = option
    }
  },
  async mounted() {
    const organization = await this.organizationGet();
    this.loading_item_data = true;
    this.get_workgroup();
    this.params.nds_value = organization.nds_value
    await this.update_modifiers();
    this.get_all_suppliers();
    this.categorySortedByPosition();
    this.update();
    this.refresh();
    if (this.target_type === "composite" && this.target === "create") {
      this.params.composite_item = true;
    } else if (this.target_type === "show_on_bot" && this.target === "create") {
      this.params.show_on_bot = true;
    } else if (this.target === "create") {
      this.params.composite_item = false;
    }

    this.headers = [
      {
        text: this.$t("item"),
        value: "product_name",
        sortable: false,
      },
      {
        text: this.$t("quantity"),
        value: "quality",
        align: "right",
        width: 100,
        sortable: false,
      },
      {
        text: this.$t("sold_by"),
        value: "sold_by",
        align: "center",
        width: 100,
        sortable: false,
      },
      {
        text: this.$t("cost"),
        value: "cost",
        width: 100,
        align: "right",
        sortable: false,
      },
      {
        text: null,
        value: "remove",
        align: "right",
        width: 60,
        sortable: false,
      },
    ];
    this.variants_headers = [
      {
        text: this.$t("variant"),
        value: "name",
        sortable: false,
      },
      { text: this.$t("price"), value: "price", sortable: false, width: 100 },
      {
        text: this.$t("currency"),
        value: "price_currency",
        sortable: false,
        width: 100,
      },
      { text: this.$t("cost"), value: "cost", sortable: false, width: 100 },
      {
        text: this.$t("currency"),
        value: "cost_currency",
        sortable: false,
        width: 100,
      },
      { text: this.$t("sku"), value: "sku", sortable: false, width: 100 },
      {
        text: this.$t("track_stock"),
        value: "is_track_stock",
        sortable: false,
        width: 100,
      },
      // {
      //   text: this.$t("barcode"),
      //   value: "barcode",
      //   sortable: false,
      //   width: 150
      // },
      { text: null, value: "remove", sortable: false, width: 30 },
    ];
    const self = this;
    document.onkeydown = function (evt) {
      var keyCode = evt ? (evt.which ? evt.which : evt.keyCode) : event.keyCode;
      if (!self.saveDisabled && keyCode === 45) {
        self.save();
      }
    };
    this.organization = organization;
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}

.file-select > .select-button {
  padding: 1rem;
  color: white;
  background-color: #2ea169;
  border-radius: 0.3rem;
  text-align: center;
  font-weight: bold;
}

.file-select > input[type="file"] {
  display: none;
}

.pointer {
  cursor: pointer;
}
</style>